import * as yup from 'yup';
import { isBefore, parseISO } from 'date-fns';

const isExpDateBefore = expirationDate => {
  if (!expirationDate) {
    return false;
  }
  return isBefore(parseISO(expirationDate), new Date());
};

const validationSchema = {
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  email: yup.string().email(),
  phone: yup
    .string()
    // eslint-disable-next-line no-useless-escape
    .matches(/^\+?\(?[0-9]{1,4}\)?[-\s\.]?(\([0-9]+\))?[0-9]+$/g),
  zip: yup
    .string()
    .matches(/^.[a-zA-Z0-9,._\s]+$/, {
      message: 'Alphanumeric characters only',
      excludeEmptyString: true
    })
    .required(),
  address1: yup.string().required(),
  address2: yup.string(),
  province: yup
    .string()
    .matches(/^.[a-zA-Z_\s]+$/, {
      message: 'Alphanumeric characters or underscores only',
      excludeEmptyString: true
    })
    .required(),
  city: yup
    .string()
    .matches(/^.[a-zA-Z_\s]+$/, {
      message: 'Alphanumeric characters or underscores only',
      excludeEmptyString: true
    })
    .required(),
  country: yup.string().required(),
  cardholderName: yup.string().required(),
  cardType: yup.string().required(),
  csv: yup.string().matches(/^[0-9()-]+$/),
  cardNumber: yup.string().matches(/^[0-9()-]+$/),
  expiryDate: yup
    .string()
    .typeError('Not a valid expiration date. Example: MM/YY')
    .max(5, 'Not a valid expiration date. Example: MM/YY')
    .matches(
      /([0-9]{2})\/([0-9]{2})/,
      'Not a valid expiration date. Example: MM/YY'
    )
    .test(
      'test-credit-card-expiration-date',
      'Invalid Expiration Date is in the past',
      expirationDate => isExpDateBefore(expirationDate)
    )
    .required('Expiration date is required'),
  password: yup
    .string()
    .matches(/^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{1,}$/, {
      message:
        'Must contain one upper case letter, one number and one special character',
      excludeEmptyString: true
    }),
  purchaseOrder: yup
    .string()
    .matches(/^.[a-zA-Z0-9,._\s]+$/, {
      message: 'Alphanumeric characters only',
      excludeEmptyString: true
    })
    .required()
};

function validatorFactory(fields) {
  const fieldsArray = fields.reduce((acc, field) => {
    acc.push([field, validationSchema[field]]);
    return acc;
  }, []);
  return Object.fromEntries(fieldsArray);
}

export { validatorFactory };
